import React from "react"
import { OnboardingSiteType } from "@modules/onboarding/shared/constants"
import { CmsIntegrationForm } from "./CmsIntegrationForm"
import { CmsProvisioningForm } from "./CmsProvisioningForm"

export function AuthorizedForm({
  type: siteType,
  siteId,
  onFinish,
  orgSiteName,
  cmsVendor,
  refetch,
  onFetchError,
  onCancel,
}) {
  const onComplete = () => {
    if (typeof refetch === "function") {
      refetch()
    }

    onFinish()
    return null
  }

  if (siteType === OnboardingSiteType.Provision) {
    return (
      <CmsProvisioningForm
        siteId={siteId}
        siteName={orgSiteName}
        cmsVendor={cmsVendor}
        onComplete={onComplete}
        onCancel={onCancel}
        onFetchError={onFetchError}
      />
    )
  } else {
    return (
      <CmsIntegrationForm
        siteId={siteId}
        siteName={orgSiteName}
        cmsVendor={cmsVendor}
        onComplete={onComplete}
        onCancel={onCancel}
        onFetchError={onFetchError}
      />
    )
  }
}
